import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import clsx from "clsx";

import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import { EModalConfirmationTypes } from "interfaces/VetExamState";
import {
  setActiveLink,
  setStoreActiveLinkCandidate
} from "store/actions/sidebar";
import { useAppSelector } from "hooks/redux/useAppSelector";
import { EMPTY_STRING } from "common/constants";
import { checkTypeModal } from "../../helper";

import useStyles from "./styles";

interface IProps {
  type: EModalConfirmationTypes;
  onCloseModal: (shouldCloseExamForm?: boolean) => void;
  closeVetExamSavingState?: () => void;
  resetExam?: () => void;
  discardExam?: () => void;
}

const VetExamModalActions = (props: IProps) => {
  const {
    type,
    onCloseModal,
    closeVetExamSavingState,
    discardExam,
    resetExam
  } = props;

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const linkCandidate = useAppSelector(
    state => state.sidebar.activeLinkCandidate
  );

  const { isPauseOrCloseModal, isResetModal, isExamEditInProgressModal } =
    checkTypeModal(type);

  const backButtonDataTestId = isResetModal
    ? "resetExamBackButton"
    : "submitExamBackButton";
  const cancelButtonDataTestId = isResetModal
    ? "resetExamResetButton"
    : "pauseOrCloseExamDiscardButton";

  const redirectToLinkCandidate = () => {
    if (linkCandidate) {
      dispatch(setActiveLink(linkCandidate));
      dispatch(setStoreActiveLinkCandidate(EMPTY_STRING));
      history.push(linkCandidate);
    }
  };

  const handleClickCancelButton = () => {
    isResetModal && resetExam?.();
    isPauseOrCloseModal && discardExam?.();
    onCloseModal(isExamEditInProgressModal);
    redirectToLinkCandidate();
  };

  const handleClickSuccessButton = () => {
    isPauseOrCloseModal && closeVetExamSavingState?.();
    onCloseModal();
    redirectToLinkCandidate();
  };

  const handleClickBackButton = () => {
    linkCandidate && dispatch(setStoreActiveLinkCandidate(EMPTY_STRING));
    onCloseModal();
  };

  return (
    <DialogActions className={classes.dialogActions}>
      <Button
        className={classes.actionButton}
        onClick={handleClickBackButton}
        data-test-id={backButtonDataTestId}
      >
        Back
      </Button>

      <Button
        className={clsx(classes.actionButton, classes.cancelButton)}
        onClick={handleClickCancelButton}
        data-test-id={cancelButtonDataTestId}
      >
        {isResetModal && "Reset Exam"}
        {isPauseOrCloseModal && "Discard Exam"}
        {isExamEditInProgressModal && "Discard Changes"}
      </Button>

      {isPauseOrCloseModal && (
        <Button
          className={clsx(classes.actionButton, classes.successButton)}
          onClick={handleClickSuccessButton}
          data-test-id={"pauseOrCloseExamPauseButton"}
        >
          {isPauseOrCloseModal && "Pause Exam"}
        </Button>
      )}
    </DialogActions>
  );
};

export default React.memo(VetExamModalActions);
